import { ReactNode } from 'react';
import { AdminPage } from './AdminPage';

export enum PageCategoryType {
  MAIN_PAGE = 'MAIN_PAGE',
  AI = 'AI',
  PRODUCTS = 'PRODUCTS',
  SALES = 'SALES',
  PAGES = 'PAGES',
  VISUAL = 'VISUAL',
  BLOG = 'BLOG',
  GENERAL_SETTINGS = 'GENERAL_SETTINGS',
  SHIPPING = 'SHIPPING',
  USERS = 'USERS',
  REPORTS = 'REPORTS',
}

export interface PageCategory {
  categoryType: PageCategoryType;
  name: string;
  icon: ReactNode;
  path: string;
  pages: AdminPage[];
}
